import React, { useRef, useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ImageDropZone({ currentUrl, onUploaded, testId = "admin-image-drop" }) {
    const [dragOver, setDragOver] = useState(false);
    const [uploading, setUploading] = useState(false);
    const inputRef = useRef(null);

    const upload = async (file) => {
        if (!file) return;
        if (!file.type.startsWith("image/")) {
            toast.error("Please pick an image file");
            return;
        }
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            const { data } = await client.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
            await onUploaded(`${BACKEND}${data.url}`);
            toast.success("Image uploaded");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Upload failed");
        } finally {
            setUploading(false);
        }
    };

    const preview = currentUrl && (currentUrl.startsWith("http") || currentUrl.startsWith("/brand") ? currentUrl : `${BACKEND}${currentUrl}`);

    return (
        <label
            data-testid={testId}
            title="Click or drop an image to replace"
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => { e.preventDefault(); setDragOver(false); upload(e.dataTransfer.files?.[0]); }}
            className={`relative block w-16 h-16 border rounded-sm overflow-hidden cursor-pointer transition-colors ${
                dragOver ? "border-brand-olive bg-brand-olive/10" : "border-brand-line hover:border-brand-gold"
            }`}
        >
            {preview ? (
                <img src={preview} alt="" className="w-full h-full object-cover" />
            ) : (
                <div className="w-full h-full flex items-center justify-center text-[10px] text-brand-mute text-center leading-tight px-1">
                    Drop image
                </div>
            )}
            {uploading && (
                <div className="absolute inset-0 bg-brand-ink/80 flex items-center justify-center text-[10px] text-brand-gold">…</div>
            )}
            <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
        </label>
    );
}
